import React from 'react'
import { useParams } from 'react-router-dom'
import CartasSiniestros from '../CartasSiniestros/CartasSiniestros'

export default function VisorCartasSiniestros() {

  const { idDenuncia } = useParams()
  //#endregion

  return (
    <div id='root'>
      <CartasSiniestros cargaHabilitada={true} idDenuncia={idDenuncia} />
    </div>
  )
}
